var mangleCardMap = function mangleCardMap(defaultCards, customCards) {
  if (defaultCards === void 0) {
    defaultCards = new Map();
  }
  var cardMaps = defaultCards;
  if (customCards && (customCards == null ? void 0 : customCards.size) > 0) {
    cardMaps = new Map([].concat(Array.from(defaultCards.entries()), Array.from(customCards.entries())));
  }
  return cardMaps;
};

/** get card component for skywalker template */
var getTemplateComponents = function getTemplateComponents(opts) {
  var templateId = opts.templateId,
    customRendererCollection = opts.customRendererCollection,
    rendererCollection = opts.rendererCollection;
  /** Allow rendring any custom cards from outside of @skywalker/card packages
    *  use-cases:
    *  * Render the adtech card form adtech sdk which is not part of skywalker cards/package
    */
  var cardMaps = mangleCardMap(rendererCollection, customRendererCollection);
  return cardMaps.get(templateId);
};

/** get data for a template */
var getDataForTemplate = function getDataForTemplate(skywalkerSequenceData, cardId) {
  return skywalkerSequenceData[cardId];
};

var getTemplate = function getTemplate(seq, rendererCollection, customRendererCollection) {
  // get the UI component for skywalker template.id
  var templateId = seq.template.id;
  var templateComponent = getTemplateComponents({
    templateId: templateId,
    rendererCollection: rendererCollection,
    customRendererCollection: customRendererCollection
  });
  return templateComponent;
};
var getTemplateData = function getTemplateData(seq, skywalkerData) {
  // get the data for above UI component
  var dataId = seq.id;
  var templateData = getDataForTemplate(skywalkerData, dataId);
  return templateData;
};
var generateCardsSequence = function generateCardsSequence(opts) {
  var skywalkerSequence = opts.skywalkerSequence,
    skywalkerData = opts.skywalkerData,
    globalData = opts.globalData,
    rendererCollection = opts.rendererCollection,
    customRendererCollection = opts.customRendererCollection;
  var cardSequence = {
    globalData: globalData,
    cardItems: []
  };
  skywalkerSequence.forEach(function (seq) {
    var templateComponent = getTemplate(seq, rendererCollection, customRendererCollection);
    var templateData = getTemplateData(seq, skywalkerData);
    cardSequence.cardItems.push({
      component: templateComponent,
      backend: {
        data: templateData,
        metadata: {
          seq: seq
        }
      }
    });

    // for nested card sequences , parent card's backend object is updated with nested cards' template id
    // acting as keys and  their values as nested template data

    if (seq != null && seq.cardSequence) {
      var _seq$cardSequence;
      var nestedCardsSequences = (seq == null || (_seq$cardSequence = seq.cardSequence) == null ? void 0 : _seq$cardSequence.data) || [];
      nestedCardsSequences.forEach(function (nestedSeq) {
        var nestedTemplateData = getTemplateData(nestedSeq, skywalkerData);
        var parentCard = cardSequence.cardItems.pop();
        if (parentCard) {
          parentCard.backend.data.data[nestedSeq.template.id] = nestedTemplateData;
          cardSequence.cardItems.push(parentCard);
        }
      });
    }
  });
  return cardSequence;
};

export { getTemplateData as a, generateCardsSequence as g };
